import React from "react";
import { injectIntl } from "react-intl";
import { SwapOutlined, WhatsAppOutlined, MessageFilled } from "@ant-design/icons";
import { hourMinuteOnly, formatTime } from "../../../../util/helpers";
import { senderTitle } from "../../SelectSender/senders";
import "./SwitchNotice.less";

// In the thread, where the customer changed how they reach us, always with the channel: "Customer switched from
// SMS to WhatsApp · same number +48 …", "Customer switched from SMS (2WAY) to WhatsApp (+48 …)" or "Customer
// wrote to +48 … (before: +48 …) · still on WhatsApp". Worked out from the messages, so every operator
// sees it, also later in the history.
const SwitchNotice = ({intl, change, phoneNumbers}) => {
    const t = (id, defaultMessage, values) => intl.formatMessage({id, defaultMessage}, values);
    const time = hourMinuteOnly(change.time);
    const isChannel = change.type === "channel";
    const channelName = value => (value === "whatsapp" ? "WhatsApp" : "SMS");
    const values = {
        channel: channelName(change.channel),
        from: channelName(change.before.channel),
        number: senderTitle(change.number, phoneNumbers),
        before: senderTitle(change.before.number, phoneNumbers, change.before.customName)
    };
    // Always says the channel, and whether the number changed with it.
    const text = !isChannel
        ? t("chats.switchNumberSameChannel", "Customer wrote to {number} (before: {before}) · still on {channel}", values)
        : change.numberChanged
            ? t("chats.switchChannelAndNumber", "Customer switched from {from} ({before}) to {channel} ({number})", values)
            : t("chats.switchChannelSameNumber", "Customer switched from {from} to {channel} · same number {number}", values);
    const Icon = !isChannel ? SwapOutlined : change.channel === "whatsapp" ? WhatsAppOutlined : MessageFilled;
    return (
        <div className={`switch-notice is-${isChannel ? change.channel : "number"}`} role="note" title={formatTime(change.time)}>
            <span className="switch-notice__pill">
                <Icon aria-hidden="true"/>
                <span>{text} · {time}</span>
            </span>
        </div>
    );
};

export default injectIntl(SwitchNotice);
